"use client";

import { Smartphone } from "lucide-react";
import { Button, Input } from "@gerama/ui";
import { env } from "@/env";
import { GoogleSignInButton } from "./google-sign-in-button";
import { AuthLogo, FormError, OrDivider, isMobileValid, normalizeMobileInput } from "./auth-bits";

export function AuthMobileForm({
  initialMobile,
  onSubmit,
  isLoading,
  error,
}: {
  initialMobile: string;
  onSubmit: (mobile: string) => void;
  isLoading: boolean;
  error?: string;
}) {
  return (
    <form
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const mobile = normalizeMobileInput(String(data.get("mobile") ?? ""));
        if (isMobileValid(mobile)) onSubmit(mobile);
      }}
    >
      <AuthLogo />
      <p className="text-muted-foreground mt-5 mb-4 text-sm">
        برای ورود یا ثبت نام، شماره موبایل خود را وارد کنید
      </p>
      <div className="relative mb-4">
        <Smartphone className="text-muted-foreground absolute top-1/2 start-2.5 size-4 -translate-y-1/2" />
        <Input
          name="mobile"
          type="tel"
          inputMode="numeric"
          autoFocus
          autoComplete="tel"
          placeholder="موبایل خود را وارد کنید"
          aria-label="موبایل خود را وارد کنید"
          defaultValue={initialMobile}
          disabled={isLoading}
          className="h-11 rounded-lg bg-muted/50 ps-9"
          onChange={(event) => {
            const mobile = normalizeMobileInput(event.target.value);
            event.target.value = mobile;
            if (isMobileValid(mobile) && !isLoading) onSubmit(mobile);
          }}
        />
      </div>
      <FormError message={error} />
      <Button type="submit" className="h-11 w-full rounded-lg" disabled={isLoading}>
        {isLoading ? "..." : "ادامه"}
      </Button>
      {env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ? (
        <>
          <OrDivider />
          <GoogleSignInButton disabled={isLoading} />
        </>
      ) : null}
    </form>
  );
}
